import { Link } from 'react-router-dom';
import { IconBolt, IconStar, IconZap } from '@/components/landing/LandingIcons';
import { Button } from '@/components/ui/Button';
import { ROUTES } from '@/constants/routes';

const highlights = [
  {
    badge: '₦230/GB',
    title: 'Cheapest Data Prices',
    desc: 'Get MTN SME data at just ₦230/GB! Lowest prices guaranteed.',
    icon: IconZap,
    tone: 'text-primary bg-primary/10',
  },
  {
    badge: '5% Bonus',
    title: 'Reseller Bonus',
    desc: 'Become a reseller and earn up to 5% commission on all transactions.',
    icon: IconStar,
    tone: 'text-secondary bg-secondary/10',
  },
  {
    badge: '< 5 Secs',
    title: 'Instant Delivery',
    desc: 'All transactions are processed within seconds. No delays!',
    icon: IconBolt,
    tone: 'text-primary bg-primary/10',
  },
];

export function PromoSection() {
  return (
    <section className="bg-brand-surface/40 py-20">
      <div className="container-page">
        <div className="overflow-hidden rounded-3xl border border-primary/20 bg-gradient-to-br from-primary/10 via-white to-secondary/10 p-8 sm:p-10">
          <div className="flex flex-wrap items-center gap-3">
            <span className="rounded-full bg-primary px-3 py-1 text-xs font-bold uppercase tracking-wide text-white">
              🔥 Limited Time Offer
            </span>
          </div>
          <h2 className="mt-4 text-2xl font-bold text-brand-navy sm:text-3xl">
            Get 1GB MTN Data for Just ₦230!
          </h2>
          <p className="mt-3 max-w-2xl text-sm leading-relaxed text-brand-muted sm:text-base">
            Don&apos;t miss out on the cheapest data prices in Nigeria. Register now and start enjoying unlimited savings on all your purchases.
          </p>
          <Link to={ROUTES.register} className="mt-6 inline-block">
            <Button size="lg">Claim Offer Now</Button>
          </Link>
        </div>

        <div className="mt-8 grid gap-6 md:grid-cols-3">
          {highlights.map((item) => (
            <article key={item.title} className="rounded-2xl border border-gray-100 bg-white p-6 shadow-soft">
              <span className={`inline-flex rounded-lg px-3 py-1 text-xs font-bold ${item.tone}`}>
                {item.badge}
              </span>
              <div className={`mt-4 inline-flex rounded-xl p-2.5 ${item.tone}`}>
                <item.icon className="h-5 w-5" />
              </div>
              <h3 className="mt-3 font-bold text-brand-navy">{item.title}</h3>
              <p className="mt-2 text-sm text-brand-muted">{item.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
